<div>
  <lucide-icon [img]="icons.shield"></lucide-icon>
  Nous n'affichons jamais l'adresse email de {{ hostName() }}.
  @if (showLearnMore()) {
    <p class="mt-2">
      Certains robots internet (web crawlers) récoltent les adresses email automatiquement et les utilisent à des fins malveillantes (spam).
      Nous n'affichons pas d'adresse email afin de protéger {{ hostName() }}.
      <button type="button" class="btn btn-link px-1" (click)="toggleShowLearnMore()">Ok</button>
    </p>
  } @else {
    <button type="button" class="btn btn-link px-1" (click)="toggleShowLearnMore()">En savoir plus</button>
  }
</div>
